/* Smile app buttons: preserve their visible labels in their accessible names.
 * Keep this independent of custom cart/video scripts and app re-render timing.
 * This does not change buttons, links, focus, or click behavior.
 */
(() => {
  const selector = 'button[class*="slp_"][aria-label]';
  const normalize = (text) => (text || '').replace(/\s+/g, ' ').trim();
  const patch = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root !== document) return;
    const buttons = new Set(root.querySelectorAll(selector));
    if (root.closest) {
      const button = root.closest(selector);
      if (button) buttons.add(button);
    }
    buttons.forEach((button) => {
      const label = normalize(button.textContent);
      if (label && button.getAttribute('aria-label') !== label) {
        button.setAttribute('aria-label', label);
      }
    });
  };
  patch(document);
  const observer = new MutationObserver((mutations) => {
    const roots = new Set();
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => roots.add(node));
      }
      roots.add(mutation.target.nodeType === Node.TEXT_NODE
        ? mutation.target.parentElement : mutation.target);
    });
    roots.forEach((root) => { if (root) patch(root); });
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });
})();
